import React from 'react';

const Button = ({ disabled, children }) => {
    return (
        <button
            disabled={disabled}
            className='btn'>
            {children}
        </button>
    );
};

export default Button;
